import useSeoMeta from '../hooks/useSeoMeta';

const SECTION = ({ title, children }) => (
  <div style={{ marginBottom: '36px' }}>
    <h2 style={{ fontFamily: "'Sora',sans-serif", fontSize: '18px', fontWeight: 700, color: '#111', marginBottom: '12px', paddingBottom: '8px', borderBottom: '1px solid #f0f0f0' }}>{title}</h2>
    <div style={{ fontSize: '14px', color: '#555', lineHeight: 1.8 }}>{children}</div>
  </div>
);

export default function MentionsLegales() {
  useSeoMeta(null, { title: 'Mentions légales — Tech Talent Accelerator', desc: 'Mentions légales du site techtalentaccelerator.com' });

  return (
    <main style={{ padding: '80px 40px', maxWidth: '760px', margin: '0 auto' }}>
      <div className="section-eyebrow">Informations légales</div>
      <h1 style={{ fontFamily: "'Sora',sans-serif", fontSize: '36px', fontWeight: 800, color: '#111', marginBottom: '8px' }}>
        Mentions légales
      </h1>
      <p style={{ fontSize: '14px', color: '#888', marginBottom: '48px' }}>Dernière mise à jour : avril 2026</p>

      <SECTION title="Éditeur du site">
        <p><strong>Tech Talent Accelerator (TTA)</strong></p>
        <p>Structure basée à Abidjan, Côte d'Ivoire</p>
        <p>Email : <a href="mailto:contact@techtalentaccelerator.com" style={{ color: 'var(--mid)' }}>contact@techtalentaccelerator.com</a></p>
        <p>Téléphone : <a href="tel:+2250769551559" style={{ color: 'var(--mid)' }}>+225 07 69 55 15 59</a></p>
      </SECTION>

      <SECTION title="Hébergement">
        <p><strong>Hostinger International Ltd.</strong></p>
        <p>61 Lordou Vironos Street, 6023 Larnaca, Chypre</p>
        <p>Site : <a href="https://www.hostinger.com" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--mid)' }}>www.hostinger.com</a></p>
      </SECTION>

      <SECTION title="Propriété intellectuelle">
        <p>L'ensemble du contenu de ce site (textes, images, logos, visuels) est la propriété exclusive de Tech Talent Accelerator ou de ses partenaires, et est protégé par les lois en vigueur sur la propriété intellectuelle.</p>
        <p style={{ marginTop: '8px' }}>Toute reproduction, représentation, modification ou exploitation, même partielle, de ces contenus est interdite sans autorisation écrite préalable.</p>
      </SECTION>

      <SECTION title="Données personnelles">
        <p>Les informations collectées via le formulaire de contact sont utilisées exclusivement pour traiter votre demande et vous répondre. Elles ne sont ni vendues ni transmises à des tiers.</p>
        <p style={{ marginTop: '8px' }}>Conformément à la réglementation applicable, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous à <a href="mailto:contact@techtalentaccelerator.com" style={{ color: 'var(--mid)' }}>contact@techtalentaccelerator.com</a>.</p>
      </SECTION>

      <SECTION title="Cookies">
        <p>Ce site n'utilise pas de cookies de traçage ou de publicité. Des cookies techniques essentiels peuvent être utilisés pour le bon fonctionnement de la navigation.</p>
      </SECTION>

      <SECTION title="Limitation de responsabilité">
        <p>TTA s'efforce d'assurer l'exactitude des informations publiées sur ce site, mais ne peut garantir leur exhaustivité ou leur mise à jour en temps réel. TTA ne saurait être tenu responsable des dommages directs ou indirects résultant de l'utilisation de ce site.</p>
      </SECTION>

      <SECTION title="Droit applicable">
        <p>Le présent site et ses mentions légales sont soumis au droit ivoirien. En cas de litige, les juridictions compétentes sont celles d'Abidjan, Côte d'Ivoire.</p>
      </SECTION>
    </main>
  );
}
